import { Stack } from '@mui/material';
import { Show, useIsMobile } from '@side/pantry';
import { useForm } from 'react-hook-form';
import { contentContainerSx } from '@/theme/contentContainerSx';
import { ClonedTransactionAlert } from '@/views/NewInteraction/ClonedTransactionAlert';
import { FormHeader } from '@/views/NewInteraction/FormHeader';
import { MLSErrorBanner } from '@/views/NewInteraction/MLSErrorBanner';
import { FormContainer as NewInteractionFormContainer } from '../../NewInteraction/FormContainer';
import { stickyStepperSx } from '../../NewInteraction/stickyStepperSx';
import { useCreateOfferContext } from '../context/CreateOfferContext';
import type { CreateOfferFormData } from '../types';
import { LinkedListingAlert } from './LinkedListingAlert';
import { Stepper } from './Stepper/Stepper';
import { StepRenderer } from './StepRenderer';

export const FormContainer = () => {
  const isMobile = useIsMobile('lg');
  const { sourceId, formContainerRef } = useCreateOfferContext();
  const {
    formState: {
      errors: { root },
    },
  } = useForm<CreateOfferFormData>();
  const { mlsError } = root ?? {};

  return (
    <NewInteractionFormContainer ref={formContainerRef}>
      {mlsError && <MLSErrorBanner />}
      {sourceId && <ClonedTransactionAlert />}
      <Show when={isMobile}>
        <Stepper sx={stickyStepperSx} />
      </Show>

      <Stack
        component="form"
        onSubmit={() => {
          // biome-ignore lint/suspicious/noConsole: Used for debugging
          console.log('create offer');
        }}
        sx={{
          ...contentContainerSx,
          pt: { xs: 2, lg: 3 },
          pb: { xs: 4.5, lg: 7 },
        }}
      >
        <FormHeader
          headerText="Create a New Offer"
          subheaderText="Pull information automatically about the property or fill in the details from scratch"
          sx={{ mb: { xs: 2, lg: 4 } }}
        />

        <LinkedListingAlert />

        <Stack
          direction={{ xs: 'column-reverse', lg: 'row' }}
          sx={{ gap: { xs: 2, lg: 7.5 } }}
        >
          <StepRenderer />
          <Show when={!isMobile}>
            <Stepper />
          </Show>
        </Stack>
      </Stack>
    </NewInteractionFormContainer>
  );
};
